import { teamImg } from './assets';

export const LEADERS = [
  {
    slot: 'ceo',
    name: 'Brandon',
    role: 'Co-Founder & CEO',
    img: teamImg('team-ceo.jpg'),
    linkedin: 'https://www.linkedin.com/in/brandonkashani/',
    facts: [
      'Brandon is on the US National Skydiving Team and has over 5,000 jumps! He is also an “influencer” on Beli. 🪂🏅🍽️',
    ],
  },
  {
    slot: 'cto',
    name: 'Steve',
    role: 'Co-Founder & CTO',
    img: teamImg('team-cto.jpg'),
    facts: [
      'Steve has rappelled down a 400-foot highrise and has built several different theatre set displays! 🏗️🎭',
    ],
  },
  {
    slot: 'cfo',
    name: 'Shannon',
    role: 'Chief Financial Officer',
    img: teamImg('team-cfo.jpg'),
    facts: [
      'Shannon has over 2,900 sky dives and was a nationally ranked amateur surfer. 🪂🏄',
    ],
  },
  {
    slot: 'partnerships',
    name: 'Jennifer',
    role: 'Director of Partnerships',
    img: teamImg('team-partnerships.jpg'),
    linkedin: 'https://www.linkedin.com/in/jennifer-hill-994a34272/',
    facts: [
      'Jenn hates mornings, loves coffee, and has hiked some of the Appalachian Trail. Just don’t ask her to do a morning meeting. ☕🥾',
    ],
  },
  {
    slot: 'game',
    name: 'Trevin',
    role: 'Head of Game Design',
    img: teamImg('team-game-designer.jpeg'),
    facts: [
      'Trevin lives in Scotland, is our Head of Fun, and has a Master’s in Design for Change, where he studied how to use games to tackle real-world problems! 🎮🏴󠁧󠁢󠁳󠁣󠁴󠁿',
    ],
  },
  {
    slot: 'lucas',
    name: 'Lucas',
    role: 'Head of Software',
    img: teamImg('team-lucas.jpg'),
    facts: [
      'Lucas used to have a hedgehog and was a math nerd in grade school. He even traveled abroad for math competitions! 🦔➗🌍',
    ],
  },
  {
    slot: 'patrik',
    name: 'Patrik',
    role: 'Head of Hardware',
    img: teamImg('team-patrik.jpg'),
    facts: [
      'At 15, Patrik played on the state hockey team, scored against one of Sweden’s top teams, and helped win a nationally televised tournament 5-4 to reach the quarterfinals. Plus, he makes great Swedish meatballs! 🏒🇸🇪',
    ],
  },
  {
    slot: 'emily',
    name: 'Emily',
    role: 'Director of Marketing',
    img: teamImg('team-emily.png'),
    facts: [
      'Emily has worked on a sheep farm north of the Arctic Circle, helped recover mummies at an archaeological dig, and has a Master’s in Medical Sonography! 🐑❄️🏺',
    ],
  },
  {
    slot: 'pm',
    name: 'Darwin',
    role: 'Project Manager',
    img: teamImg('team-pm.jpg'),
    facts: [
      'Darwin can eat a bunch of Lakatan bananas in one sitting! 🍌😋',
    ],
  },
  {
    slot: 'paul',
    name: 'Paul',
    role: 'Software Developer',
    img: teamImg('team-paul-v2.jpg'),
    facts: [
      'At 7, Paul took apart the family PC out of curiosity. Everyone panicked… until he put it back together. His first debugging session! 💻😂',
    ],
  },
  {
    slot: 'ian',
    name: 'Ian',
    role: 'Software Developer',
    img: teamImg('team-ian.jpg'),
    facts: [
      'Ian was a ballboy at Wimbledon and is technically undefeated in pumpkin carving contests! 🎾🎃',
    ],
  },
  {
    slot: 'wendell',
    name: 'Wendell',
    role: 'Software Developer',
    img: teamImg('team-wendell.jpeg'),
    facts: [
      'Wendell is somehow most productive when he hasn’t had enough sleep. He speed-runs his to-do list so he can get back to bed! 😴⚡',
    ],
  },
  {
    slot: 'jerome',
    name: 'Jerome',
    role: 'Software Developer',
    img: teamImg('team-jerome.jpg'),
    facts: [
      'Jerome loves K-pop music and pineapple on pizza. Clearly, he has great taste! 😂🍍🎶',
    ],
  },
  {
    slot: 'zakhar',
    name: 'Zakhar',
    role: 'Software Developer',
    img: teamImg('team-zakhar-v3.jpg'),
    facts: [
      'Zakhar is from Ukraine and was a professional ballroom dancer for 15 years! 🇺🇦💃🕺',
    ],
  },
  {
    slot: 'nicky',
    name: 'Nicky',
    role: 'Partner Success Manager',
    img: teamImg('team-nicky.jpg'),
    facts: [
      'Nicky has lived in Tehran, Dubai, London, and NYC. She’s an excellent investigator and self-proclaimed food critic. 👀🍴',
    ],
  },
  {
    slot: 'zachary',
    name: 'Zakary',
    role: 'Partner Success Manager',
    img: teamImg('team-zachary.jpg'),
    facts: [
      'After breaking his collarbone three times and having three knee surgeries, Zakary decided a nice, relaxed computer job was the way to go. 😂💻',
    ],
  },
  {
    slot: 'lexi',
    name: 'Lexi',
    role: 'Graphic Designer',
    img: teamImg('team-lexi.jpg'),
    facts: [
      'Lexi regularly sings the National Anthem at NHL hockey games and is also an actress living in NYC! 🎤🏒',
    ],
  },
  {
    slot: 'cristian',
    name: 'Cristian',
    role: 'Quality Analyst',
    img: teamImg('team-cristian.jpg'),
    facts: [
      'Cristian loves eating, hates cooking, and plays games to relax… only to get stressed by them instead. 📱🎮',
    ],
  },
  {
    slot: 'joshua',
    name: 'Joshua',
    role: 'Quality Analyst',
    img: teamImg('team-joshua.jpg'),
    facts: [
      'Joshua can recognize a song within seconds but has absolutely no idea what it’s called. He also enjoys breaking things just to make sure they work. 🎵🔧',
    ],
  },
];

export const PETS = [
  {
    slot: 'pet5',
    name: 'Arlo',
    role: 'Chief of Treats',
    img: teamImg('pet-treats.jpg'),
  },
  {
    slot: 'pet7',
    name: 'Josie Wales',
    role: 'Chief Relaxation Officer',
    img: teamImg('pet-josie-v3.jpg'),
    pos: 'center 35%',
  },
  {
    slot: 'pet3',
    name: 'Gator',
    role: 'Director of Naps',
    img: teamImg('pet-gator.jpg'),
  },
  {
    slot: 'pet2',
    name: 'Winston',
    role: 'Head of Unauthorized Access',
    img: teamImg('pet-winston.jpg'),
  },
  {
    slot: 'pet8',
    name: 'Kamira',
    role: 'Head of Security',
    img: teamImg('pet-kamira.jpg'),
    pos: 'center 28%',
  },
  {
    slot: 'pet9',
    name: 'Hudson',
    role: 'Director of First Impressions',
    img: teamImg('pet-hudson.jpg'),
    pos: 'center 22%',
  },
  {
    slot: 'pet1',
    name: 'Milk Toast',
    role: 'Chief Purrgrammer',
    img: teamImg('pet-milktoast.jpg'),
  },
  {
    slot: 'pet6',
    name: 'Kimchi',
    role: 'Senior Meow Engineer',
    img: teamImg('pet-kimchi.jpg'),
  },
  {
    slot: 'pet4',
    name: 'Belle',
    role: 'Guest Greetings Supervisor',
    img: teamImg('pet-belle.jpg'),
  },
  {
    slot: 'pet10',
    name: 'Tucker',
    role: 'Director of Strategic Intimidation',
    img: teamImg('pet-tucker.jpg'),
    pos: 'center 30%',
  },
];
